import { Pipe, PipeTransform } from '@angular/core'
import { Enums } from '@cyborg-monorepo/hunter/common'
import { BadgeVariant } from '@hyperkit'

@Pipe({
  name: 'statusBadge',
  pure: true,
  standalone: false,
})
export class StatusBadgePipe implements PipeTransform {
  transform(status: Enums.StatusEnum): BadgeVariant {
    switch (status) {
      case Enums.StatusEnum.TO_DO:
        return 'information'
      case Enums.StatusEnum.IN_PROGRESS:
        return 'warning'
      case Enums.StatusEnum.DONE:
        return 'success'
      default:
        return 'information'
    }
  }
}
